import entryFactory from "bpmn-js-properties-panel/lib/factory/EntryFactory";
import cmdHelper from "bpmn-js-properties-panel/lib/helper/CmdHelper";
import React from "react";
import ReactDOM from "react-dom";

import ModelerModalGroupList from "./modeler-modal-group-list";
import ModelerModalUserList from "./modeler-modal-user-list";

function BuildGroupModal(itens, elementdom, saveGroup, element) {
  ReactDOM.render(
    <ModelerModalGroupList
      FormComponents={itens}
      saveGroup={saveGroup}
      element={element}
    />,
    elementdom,
  );
}

function BuildUserModal(itens, elementdom, saveUser, element) {
  ReactDOM.render(
    <ModelerModalUserList
      FormComponents={itens}
      saveUser={saveUser}
      element={element}
    />,
    elementdom,
  );
}

export default function (element, bpmnFactory, options, translate, modeling) {
  const getBusinessObject = options.getBusinessObject;

  const saveGroup = function (element, values) {
    const bo = getBusinessObject(element);
    if (values === null || values === undefined) return;
    const listgroup = Object.keys(values);
    let candidateStarterGroups = "";
    for (let idx = 0; idx < listgroup.length; idx++) {
      if (values[listgroup[idx]] === true)
        candidateStarterGroups += listgroup[idx] + ",";
    }
    candidateStarterGroups =
      candidateStarterGroups.length > 1
        ? candidateStarterGroups.substr(0, candidateStarterGroups.length - 1)
        : candidateStarterGroups;
    bo.set("camunda:candidateStarterGroups", candidateStarterGroups);

    // document.getElementById("camunda-candidateStarterGroups").value = candidateStarterGroups;
    modeling.updateProperties(element, {});
  };

  const saveUser = function (element, values) {
    const bo = getBusinessObject(element);
    if (values === null || values === undefined) return;
    const listUser = Object.keys(values);
    let candidateStarterUsers = "";
    for (let idx = 0; idx < listUser.length; idx++) {
      if (values[listUser[idx]] === true)
        candidateStarterUsers += listUser[idx] + ",";
    }
    candidateStarterUsers =
      candidateStarterUsers.length > 1
        ? candidateStarterUsers.substr(0, candidateStarterUsers.length - 1)
        : candidateStarterUsers;
    bo.set("camunda:candidateStarterUsers", candidateStarterUsers);

    // document.getElementById("camunda-candidateStarterUsers").value = candidateStarterUsers;
    modeling.updateProperties(element, {});
  };

  const candidateStarterGroupsEntry = entryFactory.textField(translate, {
    id: "candidateStarterGroups",
    label: translate("Candidate Starter Groups"),
    modelProperty: "candidateStarterGroups",
    description: translate(
      "Specify more than one group as a comma separated list.",
    ),

    get(element, node) {
      const bo = getBusinessObject(element);
      const candidateStarterGroups = bo.get("camunda:candidateStarterGroups");

      return {
        candidateStarterGroups: candidateStarterGroups || "",
      };
    },

    set(element, values) {
      const bo = getBusinessObject(element);
      return cmdHelper.updateBusinessObject(element, bo, {
        "camunda:candidateStarterGroups":
          values.candidateStarterGroups || undefined,
      });
    },
  });

  const candidateStarterGroupsButton = {
    id: "candidateStarterGroupsButton",
    modelProperty: "candidateStarterGroupsButton",
    html:
      '<button class="add" ' +
      'id="cam-candidateStarterGroups-list" ' +
      'data-action="listGroups">' +
      "<span>...</span>" +
      "</button>",

    // eslint-disable-next-line no-empty-function
    get(element, node) {},
    // eslint-disable-next-line no-empty-function
    set(element, values) {},
    listGroups(element, values) {
      const bo = getBusinessObject(element);
      const candidateStarterGroups = bo.get("camunda:candidateStarterGroups");
      const groups = {};

      const itens = candidateStarterGroups
        ? candidateStarterGroups.split(",")
        : [];
      for (let idx = 0; idx < itens.length; idx++) {
        groups[itens[idx]] = true;
      }

      const modalGroup = document.createElement("modalGroup");
      BuildGroupModal(groups, modalGroup, saveGroup, element);
    },
  };

  const candidateStarterUsersEntry = entryFactory.textField(translate, {
    id: "candidateStarterUsers",
    label: translate("Candidate Starter Users"),
    modelProperty: "candidateStarterUsers",
    description: translate(
      "Specify more than one user as a comma separated list.",
    ),

    get(element, node) {
      const bo = getBusinessObject(element);
      const candidateStarterUsers = bo.get("camunda:candidateStarterUsers");

      return {
        candidateStarterUsers: candidateStarterUsers || "",
      };
    },

    set(element, values) {
      const bo = getBusinessObject(element);
      return cmdHelper.updateBusinessObject(element, bo, {
        "camunda:candidateStarterUsers":
          values.candidateStarterUsers || undefined,
      });
    },
  });

  const candidateStarterUsersButton = {
    id: "candidateStarterUsersButton",
    modelProperty: "candidateStarterUsersButton",
    html:
      '<button class="add" ' +
      'id="cam-candidateStarterUsers-list" ' +
      'data-action="listUsers">' +
      "<span>...</span>" +
      "</button>",
    // eslint-disable-next-line no-empty-function
    get(element, node) {},
    // eslint-disable-next-line no-empty-function
    set(element, values) {},
    listUsers(element, values) {
      const bo = getBusinessObject(element);
      const candidateStarterUsers = bo.get("camunda:candidateStarterUsers");
      const Users = {};

      const itens = candidateStarterUsers
        ? candidateStarterUsers.split(",")
        : [];
      for (let idx = 0; idx < itens.length; idx++) {
        Users[itens[idx]] = true;
      }

      const modalUser = document.createElement("modalUser");

      BuildUserModal(Users, modalUser, saveUser, element);
    },
  };

  return [
    candidateStarterGroupsButton,
    candidateStarterGroupsEntry,
    candidateStarterUsersButton,
    candidateStarterUsersEntry,
  ];
}
